import isValidHtmlProp from "@emotion/is-prop-valid";
export const isValidProp = (prop: string) => isValidHtmlProp(prop);
